__turbopack_context__.v({
  "deliveryTimesOfTheDay": "K-LyhW_deliveryTimesOfTheDay",
  "mobileContent": "K-LyhW_mobileContent",
});
